import { render, staticRenderFns } from "./JobfairSettingsModal.vue?vue&type=template&id=6720afee&scoped=true"
import script from "./JobfairSettingsModal.vue?vue&type=script&lang=js"
export * from "./JobfairSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./JobfairSettingsModal.vue?vue&type=style&index=0&id=6720afee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6720afee",
  null
  
)

export default component.exports